module.exports = __webpack_public_path__ + "static/media/text-logo-2.2b3c43a2.svg";